import TextInput from '@/Shared/Inputs/Text';
import TextArea from '@/Shared/Inputs/Textarea';
import Typeahead from '@/Shared/Inputs/NewTypeahead';
import Choice from '@/Shared/Inputs/Choice';
import LoadingButton from '@/Shared/LoadingButton';
import Radio from '@/Shared/Inputs/CustomRadio';
import Error from '@/Shared/Inputs/Error';
import OldTypeahead from '@/Shared/Inputs/Typeahead';

export default {
  components: {
    TextArea,
    Typeahead,
    TextInput,
    Choice,
    Radio,
    Error,
    LoadingButton,
    OldTypeahead,
  },

  props: {
    workCategories: Array,
    counterParties: Array,
    organisations: Array,
    asset: Object,
    submitTrigger: String,
  },

  data() {
    return {
      counterPartiesData: this.counterParties,
      counterParty: null,
      sending: false,
    };
  },

  watch: {
    submitTrigger() {
      this.$emit('submitted', this.form);
    },
  },

  computed: {
    allAvailableCounterParties() {
      const modifiedOrganisations = this.organisations.map((org) => ({
        id: org.id,
        type: 'App\\Models\\Organisation',
        name: org.name,
      }));

      const modifiedCounterParties = this.counterPartiesData.map((cp) => ({
        id: cp.id,
        type: 'App\\Models\\CounterParty',
        name: cp.name,
        address: cp.address,
        registered_number: cp.registered_number,
      }));

      return [...modifiedOrganisations, ...modifiedCounterParties].filter((org) => org.id);
    },
  },
};
